import { doc, setDoc } from "firebase/firestore";
import { db } from "../../firebase/config";

function participantRef(competitionId, participantId) {
  return doc(db, "competitions", competitionId, "participants", participantId);
}

/**
 * @param {string} competitionId
 * @param {{ participantId: string, displayName?: string, playerId?: string | null, registryEntryId: string }} row
 */
export async function upsertCompetitionParticipant(competitionId, row) {
  await setDoc(
    participantRef(competitionId, row.participantId),
    {
      participantId: row.participantId,
      competitionId,
      registryEntryId: row.registryEntryId,
      playerId: row.playerId || null,
      display: row.displayName || "",
      status: "active",
      updatedAtMs: Date.now(),
    },
    { merge: true }
  );
}
